<template>
  <div id="userEditWrapper">
    <div class="columns">
      <div class="column">
        <div class="notification" v-show="loading">Laden...</div>
      </div>
    </div>

    <div class="columns">
      <div v-if="isAdmin && !myAccount" class="column is-one-fifth">
        <p><router-link :to="{ name: 'users' }"><span class="icon"><i class="fas fa-chevron-left"></i></span> Terug</router-link></p>
      </div>

      <div class="column is-four-fifths-tablet is-half-desktop">
        <div class="card">
          <http-messages :success="success" :errors="errors" :message="message"></http-messages>

          <header class="card-header">
            <p class="card-header-title">Persoonlijke gegevens</p>
          </header>

          <div class="card-content">
            <form>
              <div class="field">
                <label for="firstname" class="label">Voornaam/-letters *</label>
                <div class="control">
                  <input
                  class="input"
                  type="text"
                  name="firstname"
                  :class="{ 'is-danger': errors.firstname }"
                  v-model="user.firstname">
                </div>
                <p v-for="message in errors.firstname" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="lastname" class="label">Achternaam *</label>
                <div class="control">
                  <input
                  class="input"
                  type="text"
                  name="lastname"
                  :class="{ 'is-danger': errors.lastname }"
                  v-model="user.lastname">
                </div>
                <p v-for="message in errors.lastname" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="email" class="label">E-mail adres *</label>
                <div class="control">
                  <input
                  class="input"
                  type="text"
                  name="email"
                  :class="{ 'is-danger': errors.email }"
                  v-model="user.email">
                </div>
                <p v-for="message in errors.email" class="help is-danger">{{ message }}</p>
              </div>

              <div class="field">
                <label for="phone" class="label">Telefoon/Mobiel *</label>
                <div class="control">
                  <input
                  class="input"
                  type="text"
                  name="phone"
                  :class="{ 'is-danger': errors.phone }"
                  v-model="user.phone">
                </div>
                <p v-for="message in errors.phone" class="help is-danger">{{ message }}</p>
              </div>

              <template v-if="!isAdmin || myAccount">
                <div class="field">
                  <label for="password" class="label">Wachtwoord *</label>
                  <div class="control">
                    <input
                    class="input"
                    type="password"
                    name="password"
                    :class="{ 'is-danger': errors.password, 'is-success': passwordsMatch }"
                    v-model="user.password">
                  </div>
                  <p v-for="message in errors.password" class="help is-danger">{{ message }}</p>
                </div>

                <div class="field">
                  <label for="password_confirmation" class="label">Voer nogmaals het wachtwoord in ter controle *</label>
                  <div class="control">
                    <input
                      class="input"
                      type="password"
                      name="password_confirmation"
                      :class="{ 'is-danger': errors.password_confirmation, 'is-success': passwordsMatch }"
                      v-model="user.password_confirmation">
                    </div>
                    <p v-for="message in errors.password_confirmation" class="help is-danger">{{ message }}</p>
                  </div>
                </template>
              </form>
            </div>

            <footer class="card-footer">
              <a
              class="button is-text card-footer-item"
              @click="save"
              :class="{ 'is-loading': loading }">
              Opslaan
            </a>
          </footer>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-four-fifths-tablet is-offset-one-fifth-tablet is-half-desktop">
        <button v-if="isAdmin && user.id != accountData.id" type="button" class="button is-danger" @click="delUser">Gebruiker verwijderen</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import HttpMessages from '@/components/http/HttpMessages'

  export default {
    components: {
      HttpMessages
    },
    data () {
      return {
        loading: false,
        errors: {},
        success: false,
        signup: false,
        user: {},
        message: null
      }
    },
    computed: {
      passwordsMatch () {
        if (this.user.password)
          if (this.user.password.length > 6 && this.user.password === this.user.password_confirmation)
            return true

        return false
      },
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      myAccount () {
        return this.$store.getters.accountData.id === this.user.id
      },
      accountData () {
        return this.$store.getters.accountData
      },
      message2 () {
        if (!this.isAdmin || this.myAccount) {
          return 'Uw account is gemaakt. Wij hebben een e-mail gestuurd naar ' + this.user.email + ' ter verificatie van het e-mail adres. Klik op de link in de e-mail om uw account te activeren.'
        } else {
          return 'De gegevens zijn succesvol opgeslagen.'
        }
      }
    },
    created () {
      if (this.$store.getters.isAdmin) {
        if (this.$route.path === '/account') {
          this.user = this.accountData
        } else {
          if (this.$route.params.id) this.fetchUser(this.$route.params.id)
        }
      } else if (this.$store.getters.isLoggedIn) {
        this.user = this.accountData
      }
    },
    methods: {
      isEmpty(obj) {
        for(var key in obj) {
          if (obj.hasOwnProperty(key)) {
            return false
          }
        }

        return true
      },
      fetchUser (id = false) {
        this.loading = true

        axios
          .get('/users/' + id)
          .then(response => {
            this.loading = false
            this.user = response.data
          }).catch(error => {
            this.loading = false
            this.errors = error.response.data.message || error.message;
          });
      },
      save () {
        this.success = false
        this.loading = true
        this.errors = {}

        if (this.user.id) {
          axios
            .put('/users/' + this.user.id,
              this.user
            )
            .then(response => {
              this.loading = false
              this.success = true
              this.message = 'De gegevens zijn succesvol opgeslagen.'
              if (this.$route.path === '/account') this.$store.dispatch('updateAccountData', this.user)
            })
            .catch(error => {
              this.loading = false
              this.errors = error.response.data.errors
            });
        } else {
          let uri = '/auth/signup'

          if (this.isAdmin)
            uri = '/users'

          axios
            .post(uri,
              this.user
            )
            .then(response => {
              this.loading = false
              this.success = true
              if (response.status === 201) {
                this.message = (this.isAdmin) ? 'De nieuwe gebruiker is opgeslagen' : 'Uw account is gemaakt. Wij hebben een e-mail gestuurd naar ' + this.user.email + ' ter verificatie van het e-mail adres. Klik op de link in de e-mail om uw account te activeren.'
                this.signup = true
              }
            })
            .catch(error => {
              this.loading = false
              this.errors = error.response.data.errors
            });
        }
      },
      delUser () {
        axios
          .delete('/users/' + this.user.id)
          .then(response => {
            this.$router.push({name: 'users'})
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
  }
</script>

<style scoped>
  .button.is-text {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UserEdit.vue